import FacialAccessForm from "@/components/views/invitations/FacialAccessForm.vue";
import PhotoUploadForm from "../../components/views/users/PhotoUploadForm.vue";

export default [
  { path: "/", component: FacialAccessForm, name: "root" },
  { path: "/users", component: PhotoUploadForm },
];
